import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './assets/metaRV/successVoice.wav';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0
}, null, -1);
const _hoisted_2 = [_hoisted_1];
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { getSSOPublicKeyAPI } from './api/login';
const __default__ = {
  computed: {}
};
export default /*#__PURE__*/Object.assign(__default__, {
  __name: 'App',
  setup(__props) {
    const store = useStore();
    const appStyle = computed(() => {
      let themeColor = store.state.themeColor;
      let themeColors = ['#e5e5e5', '#111'];
      let themeColors2 = ['#111', '#fff'];
      let themeColors3 = ['#fff', '#282727'];
      let themeColors4 = ['#282727', '#000'];
      let themeColors5 = ['#eee', '#000'];
      let themeColors6 = ['#003247', 'linear-gradient(2.09deg, #0C7BB3 -4%, #F2BAE8 118.44%)'];
      return {
        theme: `--theme: ${themeColors[themeColor]}`,
        theme2: `--theme2: ${themeColors2[themeColor]}`,
        theme3: `--theme3: ${themeColors3[themeColor]}`,
        theme4: `--theme4: ${themeColors4[themeColor]}`,
        theme5: `--theme5: ${themeColors5[themeColor]}`,
        theme6: `--theme6: ${themeColors6[themeColor]}`
      };
    });
    onMounted(() => {
      let oldUserSesson = localStorage.getItem("userData");
      if (oldUserSesson) {
        localStorage.removeItem("userData");
      }
    });
    const initgongyao = () => {
      getSSOPublicKeyAPI().then(res => {
        // console.log('公钥',res);
        if (res.data.code == 1) {
          localStorage.setItem('gongyao', res.data.data);
        } else {}
      });
    };
    initgongyao();
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    var wd = document.body.clientWidth;
    store.commit('changepagewidth', wd);
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      // console.log(vh);
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      wd = document.body.clientWidth;
      store.commit('changepagewidth', wd);
    });
    if (!window.localStorage) {
      console.log("浏览器不支持localstorage");
    }

    //websocket
    const audioref = ref(null);
    const ws = ref(null);
    //域名
    const to = ref("mylunchbox.app");
    const xmlns = ref("urn:ietf:params:xml:ns:xmpp-framing");
    const version = ref("1.0");
    const xmllang = ref("en");
    const resource = ref("appClient");
    //JID
    const from = ref('lb_0_c@mylunchbox.app');
    const id = ref(null);
    const username = ref("lb_0_c");
    const password = ref("lblb_0_c");
    // ws other
    const loginregistr = ref("login");
    const registername = ref(null);
    const registerpass = ref(null);
    const userInfo = ref(null);
    const wcJT = () => {
      ws.value = new WebSocket('wss://order.lunchbox.asia:7443/ws/', "xmpp");
      // ws.value=new WebSocket('ws://139.224.17.126:7070/ws/',"xmpp");//cloud测试服务器

      // 
      ws.value.onopen = function (evt) {
        console.log("open");
        opena();
      };
      ws.value.onclose = function (evt) {
        console.log("close");
      };
      ws.value.onerror = function (evt) {
        console.log("error", evt);
      };
      ws.value.onmessage = function (event) {
        console.log("message", event.data);
        var jsondata = xml2json(event.data);
        if (undefined != jsondata.message) {
          if (undefined != jsondata.message.body) {
            console.log("收到的消息：", jsondata.message.body);
            let tempfanhui = JSON.parse(jsondata.message.body);
            if ((tempfanhui.type == 4 || tempfanhui.type == 3) && tempfanhui.push == "push_order") {
              audioref.value.play();
            }
          } else if (undefined != jsondata.message.composing) {
            console.log("对方正在输入");
          } else if (undefined != jsondata.message.gone) {
            console.log("对方已关闭和您的聊天");
          } else if (undefined != jsondata.message.file) {
            console.log("收到的文件：", jsondata.message);
          } else {}
        } else if (undefined != jsondata.open) {
          //记录id	
          id.value = jsondata.open["-id"];
          console.log(id.value);
        } else if (undefined != jsondata["stream:features"]) {
          if (undefined != jsondata["stream:features"].mechanisms) {
            //获取登录验证方式
            auth(jsondata["stream:features"].mechanisms.mechanism[0]);
          } else if (undefined != jsondata["stream:features"].bind) {
            bind();
          } else {
            //Do-nothing
            // console.log("不应该跑这儿")
          }
        } else if (undefined != jsondata.failure) {
          // islogin = false;
          console.log("登录失败，用户名或者密码错误");
          if (event.data.indexOf("not-authorized") != -1) {
            loginregistr.value = "zhuce";
            from.value = "lb_daddy_c@mylunchbox.app";
            username.value = "lb_daddy_c";
            password.value = "lblb_daddy_c";
            // opena();
            auth("PLAIN");
          }
        } else if (undefined != jsondata.success) {
          // islogin = true;
          console.log("登录成功！");
          //发起新的流
          if (loginregistr.value == "login") {
            console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaa");
            newopen();
          } else if (loginregistr.value == "zhuce") {
            registername.value = "lb_" + userInfo.value.id + "_c";
            registerpass.value = "lblb_" + userInfo.value.id + "_c";
            register();
            loginregistr.value == "login";
          }
        } else if (undefined != jsondata.iq) {
          if (undefined != jsondata.iq.bind) {
            //获取session会话
            getsession();
          } else {
            presence();
          }
        } else {
          //Do-nothing
          // console.log("莫名其妙")
        }
      };
    };

    //json转xml
    const json2xml = jsonstring => {
      var xotree = new XML.ObjTree();
      var xml = xotree.writeXML(jsonstring);
      //使用jkl-dumper.js中的formatXml方法将xml字符串格式化
      //var xmlText = formatXml(xml);
      return xml;
    };

    //xml转json
    const xml2json = xmlstring => {
      //将xml字符串转为json
      var xotree = new XML.ObjTree();
      var json = xotree.parseXML(xmlstring);
      //将json对象转为格式化的字符串
      var dumper = new JKL.Dumper();
      var jsonText = dumper.dump(json);
      return JSON.parse(jsonText);
    };
    // 连接成功之后操作
    function opena() {
      var temp = {
        "open": {
          "-to": to.value,
          "-from": from.value,
          "-xmlns": xmlns.value,
          "-xml:lang": xmllang.value,
          "-version": version.value
        }
      };
      //转化为xml
      var steam = json2xml(temp);
      ws.value.send(steam);
    }
    //登录验证
    function auth(authentication) {
      //字符串格式是：jid+password，以\0作为分隔符
      var temp = username.value + "@" + to.value + "\0" + password.value;
      //Base64编码
      var token = window.btoa(temp);
      // var message = "<auth xmlns='urn:ietf:params:xml:ns:xmpp-sasl' mechanism='PLAIN'>" + token + "</auth>";
      var message = {
        "auth": {
          "-xmlns": "urn:ietf:params:xml:ns:xmpp-sasl",
          "-mechanism": authentication,
          "#text": token
        }
      };
      ws.value.send(json2xml(message));
    }
    //发起新的流
    function newopen() {
      // <open xmlns='jabber:client' to='127.0.0.1' version='1.0' from='wuxinzhe@127.0.0.1' id='70tvu3ooiu' xml:lang='zh'/>
      var temp = {
        "open": {
          "-xmlns": "jabber:client",
          "-to": to.value,
          "-version": version.value,
          "-from": from.value,
          "-id": id.value,
          "-xml:lang": xmllang.value
        }
      };
      //转化为xml
      var steam = json2xml(temp);
      ws.value.send(steam);
    }
    //bind操作
    function bind() {
      var temp = {
        "iq": {
          "-id": id.value,
          "-type": "set",
          "bind": {
            "-xmlns": "urn:ietf:params:xml:ns:xmpp-bind",
            "resource": resource.value
          }
        }
      };
      //转化为xml
      var steam = json2xml(temp);
      ws.value.send(steam);
    }
    //获取session
    function getsession() {
      //<iq xmlns="jabber:client" id="ak014gz6x7" type="set"><session xmlns="urn:ietf:params:xml:ns:xmpp-session"/></iq>
      var temp = {
        "iq": {
          "-xmlns": "jabber:client",
          "-id": id.value,
          "-type": "set",
          "session": {
            "-xmlns": "urn:ietf:params:xml:ns:xmpp-session"
          }
        }
      };
      //转化为xml
      var steam = json2xml(temp);
      ws.value.send(steam);
    }
    //上线
    function presence() {
      //<presence id="ak014gz6x7"><status>Online</status><priority>1</priority></presence>
      var temp = {
        "presence": {
          "-id": id.value,
          "status": "online",
          "priority": "1"
        }
      };
      //转化为xml
      var steam = json2xml(temp);
      ws.value.send(steam);
    }
    // 注册
    function register() {
      console.log("执行了注册代码");
      var temp = {
        'iq': {
          '-to': to.value,
          '-id': id.value,
          '-type': 'set',
          'query': {
            '-xmlns': 'jabber:iq:register',
            'username': registername.value,
            'password': registerpass.value,
            'email': ''
          }
        }
      };
      //转化为xml
      var steam = json2xml(temp);
      ws.value.send(steam);
      // 注册成功重新执行open方法
      opena();
    }
    let userInfosess = store.state.userData;
    // console.log(userInfosess);
    if (userInfosess == null || userInfosess == "" || userInfosess == undefined) {} else {
      userInfo.value = JSON.parse(userInfosess);
      from.value = 'lb_' + userInfo.value.id + '_c@mylunchbox.app';
      username.value = "lb_" + userInfo.value.id + "_c";
      password.value = "lblb_" + userInfo.value.id + "_c";

      // wcJT();
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        id: "app",
        style: _normalizeStyle([appStyle.value.theme, appStyle.value.theme2, appStyle.value.theme3, appStyle.value.theme4, appStyle.value.theme5, appStyle.value.theme6])
      }, [_createVNode(_component_router_view), _withDirectives(_createElementVNode("audio", {
        controls: "",
        ref_key: "audioref",
        ref: audioref
      }, _hoisted_2, 512), [[_vShow, 2 != 2]])], 4);
    };
  }
});